/*
 * @Author: chenyan
 * @Date: 2017-12-19 15:20:35
 * @Description: 加密库
 * @Last Modified by: chenyan
 * @Last Modified time: 2018-01-08 20:01:07
 */

const sha256 = require('js-sha256')

export default {
  name: 'js-sha256'
}
